import React, { useState } from 'react';

// ─── Константи ─────────────────────────────────────────────────────────────

const PROJECTS = [
  { id: 'ava',  emoji: '🎭', name: 'AVA',  full: 'MediaAvatar',         color: 'var(--ac2, #a78bfa)' },
  { id: 'uniq', emoji: '🎬', name: 'UNIQ', full: 'Media Uniqueizer Bot', color: '#34d399' },
  { id: 'pl',   emoji: '🎓', name: 'PL',   full: 'PlayLanguage',         color: '#60a5fa' },
];

const SCENARIOS = [
  {
    id: 'same_pc',
    icon: '💻',
    title: 'Той самий ПК',
    subtitle: 'Claude Code вже налаштований тут',
    color: '#34d399',
    badge: 'Найшвидше',
    steps: [
      {
        label: 'Вибери проект і введи в Claude Code',
        type: 'command_picker',
      },
      {
        label: 'Claude прочитає BOOTSTRAP + STATE + COORDINATION і видасть резюме за ~10 секунд',
        type: 'info',
        text: '✅ [PROJECT] завантажено\nОстаннє: D-XXX — [опис]\nСтан серверів: 🟢🟢🟢🟢\nНаступне: [перша задача]\nГотовий до роботи.',
      },
    ],
  },
  {
    id: 'new_pc',
    icon: '🖥️',
    title: 'Новий ПК / новий акаунт',
    subtitle: 'Перший запуск на цій машині',
    color: '#60a5fa',
    badge: '2 кроки',
    steps: [
      {
        label: 'Крок 1 — Онбординг нової машини (одноразово)',
        type: 'copy',
        text: '/onboard',
        desc: 'Skill прочитає ONBOARDING.md, заповнить memory-файли, перевірить SSH і GitHub доступ',
      },
      {
        label: 'Крок 2 — Вибери проект і завантаж контекст',
        type: 'command_picker',
      },
    ],
  },
  {
    id: 'no_skills',
    icon: '📋',
    title: 'Skills не працюють',
    subtitle: 'Ручне відновлення контексту',
    color: '#f59e0b',
    badge: 'Fallback',
    steps: [
      {
        label: 'Вибери проект і скопіюй текст для вставки в Claude',
        type: 'manual_picker',
      },
    ],
  },
  {
    id: 'emergency',
    icon: '🚨',
    title: 'Немає доступу до Claude',
    subtitle: 'Тільки файли та термінал',
    color: '#f87171',
    badge: 'Екстрений',
    steps: [
      {
        label: 'SSH до серверів',
        type: 'copy',
        text: 'ssh root@10.0.0.4',
        desc: 'Публічний вхід через test-сервер (потрібен WireGuard)',
      },
      {
        label: 'Стан сервісів (n8n)',
        type: 'copy',
        text: 'ssh root@10.0.0.4 "ssh -i /root/.ssh/id_ed25519_sync_celery root@10.0.0.3 \'supervisorctl status\'"',
        desc: 'Перевірити telegram_bot, celery_worker, watchdog',
      },
      {
        label: 'Стан черги Celery',
        type: 'copy',
        text: 'ssh root@10.0.0.4 "ssh -i /root/.ssh/id_ed25519_sync_celery root@10.0.0.3 \'celery -A celery_tasks inspect ping -t 5\'"',
        desc: 'скільки nodes очікувати — дивись Систему/Памʼять AI: кількість змінюється разом з виділеними воркерами',
      },
      {
        label: 'Переглянути STATE.md будь-якого проекту',
        type: 'copy',
        text: 'cat /home/cc_media/videobot-docs/_SESSIONS/ava/STATE.md',
        desc: 'Замінити ava → uniq або pl для інших проектів',
      },
      {
        label: 'Останні коміти (хронологія)',
        type: 'copy',
        text: 'cd /home/cc_media/videobot-docs && git log --oneline -10',
        desc: 'Швидкий огляд що робилось',
      },
    ],
  },
];

const MANUAL_TEMPLATES = {
  ava: `Продовжуй проект AVA (MediaAvatar).
Прочитай по черзі:
1. /home/cc_media/videobot-docs/_SESSIONS/ava/BOOTSTRAP.md
2. /home/cc_media/videobot-docs/_SESSIONS/ava/STATE.md
3. /home/cc_media/videobot-docs/COORDINATION.md

Потім скажи: останній D-номер, стан серверів, наступна задача, активні баги.`,
  uniq: `Продовжуй проект UNIQ (Media Uniqueizer Bot).
Прочитай по черзі:
1. /home/cc_media/videobot-docs/_SESSIONS/uniq/BOOTSTRAP.md
2. /home/cc_media/videobot-docs/_SESSIONS/uniq/STATE.md
3. /home/cc_media/videobot-docs/COORDINATION.md

Потім скажи: останній D-номер, стан серверів, наступна задача, активні баги.`,
  pl: `Продовжуй проект PL (PlayLanguage).
Прочитай по черзі:
1. /home/cc_media/videobot-docs/_SESSIONS/pl/BOOTSTRAP.md
2. /home/cc_media/videobot-docs/_SESSIONS/pl/STATE.md
3. /home/cc_media/videobot-docs/COORDINATION.md

Потім скажи: останній D-номер, стан серверів, наступна задача, активні баги.`,
};

const RITUAL = [
  { num: '1', text: 'Оновити', code: '_SESSIONS/[project]/STATE.md', desc: 'Записати D-номер, результат, наступні задачі' },
  { num: '2', text: 'Додати рядок у', code: 'COORDINATION.md', desc: 'Журнал деплоїв — нові зверху' },
  { num: '3', text: 'Зберегти в git', code: 'git commit && git push', desc: 'Щоб наступна сесія бачила актуальний стан' },
];

// ─── Стилі ─────────────────────────────────────────────────────────────────

const s = {
  page: { padding: '24px', maxWidth: 1100, margin: '0 auto', color: '#e2e8f0', fontFamily: 'inherit' },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 },
  sub: { fontSize: 13, color: '#64748b', marginBottom: 28 },
  sectionTitle: { fontSize: 13, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12, marginBottom: 32 },
  scenarioCard: (active, color) => ({
    background: active ? `${color}18` : 'rgba(255,255,255,.04)',
    border: `2px solid ${active ? color : 'rgba(255,255,255,.08)'}`,
    borderRadius: 14, padding: '18px 16px', cursor: 'pointer',
    transition: 'all .2s', position: 'relative', overflow: 'hidden',
  }),
  badge: (color) => ({
    position: 'absolute', top: 10, right: 10,
    background: `${color}22`, color, border: `1px solid ${color}44`,
    borderRadius: 20, padding: '2px 8px', fontSize: 10, fontWeight: 700,
  }),
  scenarioIcon: { fontSize: 28, marginBottom: 8 },
  scenarioTitle: (active, color) => ({ fontSize: 15, fontWeight: 700, color: active ? color : '#e2e8f0', marginBottom: 3 }),
  scenarioSub: { fontSize: 12, color: '#64748b' },
  details: (color) => ({
    background: 'rgba(0,0,0,.25)', border: `1px solid ${color}33`,
    borderRadius: 14, padding: '24px', marginBottom: 32,
  }),
  stepRow: { display: 'flex', gap: 14, marginBottom: 20, alignItems: 'flex-start' },
  stepNum: (color) => ({
    minWidth: 28, height: 28, borderRadius: '50%',
    background: `${color}22`, color, border: `1px solid ${color}44`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 12, fontWeight: 700, marginTop: 2, flexShrink: 0,
  }),
  stepLabel: { fontSize: 14, fontWeight: 600, color: '#cbd5e1', marginBottom: 8 },
  stepDesc: { fontSize: 12, color: '#64748b', marginTop: 4 },
  codeBlock: (color) => ({
    background: 'rgba(0,0,0,.5)', border: `1px solid ${color}33`,
    borderRadius: 8, padding: '12px 14px', fontFamily: 'monospace',
    fontSize: 12, color: '#86efac', position: 'relative', whiteSpace: 'pre-wrap', wordBreak: 'break-all',
  }),
  copyBtn: (copied, color) => ({
    position: 'absolute', top: 8, right: 8,
    background: copied ? `${color}33` : 'rgba(255,255,255,.07)',
    border: `1px solid ${copied ? color : 'rgba(255,255,255,.15)'}`,
    color: copied ? color : '#94a3b8',
    borderRadius: 6, padding: '3px 10px', fontSize: 11, cursor: 'pointer',
    transition: 'all .2s',
  }),
  projectPicker: { display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 },
  projBtn: (active, color) => ({
    padding: '8px 16px', borderRadius: 10,
    background: active ? `${color}22` : 'rgba(255,255,255,.05)',
    border: `1px solid ${active ? color : 'rgba(255,255,255,.1)'}`,
    color: active ? color : '#94a3b8', cursor: 'pointer', fontSize: 13,
    fontWeight: active ? 700 : 400, transition: 'all .15s',
  }),
  infoBox: (color) => ({
    background: `${color}0a`, border: `1px solid ${color}22`,
    borderRadius: 8, padding: '12px 14px', fontFamily: 'monospace',
    fontSize: 12, color: '#94a3b8', whiteSpace: 'pre', marginTop: 4,
  }),
  ritualCard: { background: 'rgba(255,255,255,.04)', borderRadius: 12, padding: '20px 24px', marginBottom: 12 },
  ritualGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10 },
  ritualItem: (i) => ({
    display: 'flex', gap: 12, alignItems: 'flex-start',
    background: 'rgba(0,0,0,.2)', borderRadius: 10, padding: 14,
    borderLeft: `3px solid ${['#34d399','#60a5fa','var(--ac2, #a78bfa)'][i]}`,
  }),
  ritualNum: (i) => ({
    minWidth: 24, height: 24, borderRadius: '50%',
    background: `${['#34d399','#60a5fa','var(--ac2, #a78bfa)'][i]}22`,
    color: ['#34d399','#60a5fa','var(--ac2, #a78bfa)'][i],
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 12, fontWeight: 700, flexShrink: 0,
  }),
  inlineCode: { background: 'rgba(0,0,0,.4)', borderRadius: 5, padding: '1px 6px', fontFamily: 'monospace', fontSize: 11, color: '#86efac' },
};

// ─── Компоненти ─────────────────────────────────────────────────────────────

function CopyBlock({ text, color = '#34d399', multiline = false }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      const ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta);
      ta.select(); document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <div style={{ ...s.codeBlock(color), paddingRight: 80, marginTop: 4 }}>
      {text}
      <button style={s.copyBtn(copied, color)} onClick={copy}>
        {copied ? '✓ Скопійовано' : '⎘ Копіювати'}
      </button>
    </div>
  );
}

function CommandPicker({ color }) {
  const [proj, setProj] = useState('ava');
  const p = PROJECTS.find(x => x.id === proj);
  return (
    <div>
      <div style={s.projectPicker}>
        {PROJECTS.map(p => (
          <button key={p.id} style={s.projBtn(proj === p.id, p.color)} onClick={() => setProj(p.id)}>
            {p.emoji} {p.name}
          </button>
        ))}
      </div>
      <div style={{ marginTop: 10 }}>
        <CopyBlock text={`/resume ${proj}`} color={p.color} />
        <div style={{ fontSize: 11, color: '#64748b', marginTop: 6 }}>
          Прочитає <span style={s.inlineCode}>_SESSIONS/{proj}/BOOTSTRAP.md</span> + <span style={s.inlineCode}>STATE.md</span> + <span style={s.inlineCode}>COORDINATION.md</span>
        </div>
      </div>
    </div>
  );
}

function ManualPicker({ color }) {
  const [proj, setProj] = useState('ava');
  const p = PROJECTS.find(x => x.id === proj);
  return (
    <div>
      <div style={s.projectPicker}>
        {PROJECTS.map(p => (
          <button key={p.id} style={s.projBtn(proj === p.id, p.color)} onClick={() => setProj(p.id)}>
            {p.emoji} {p.name}
          </button>
        ))}
      </div>
      <div style={{ marginTop: 10 }}>
        <CopyBlock text={MANUAL_TEMPLATES[proj]} color={p.color} multiline />
        <div style={{ fontSize: 11, color: '#64748b', marginTop: 6 }}>
          Вставити цей текст на початку нової сесії Claude
        </div>
      </div>
    </div>
  );
}

function StepBlock({ step, idx, color }) {
  return (
    <div style={s.stepRow}>
      <div style={s.stepNum(color)}>{idx + 1}</div>
      <div style={{ flex: 1 }}>
        <div style={s.stepLabel}>{step.label}</div>
        {step.type === 'copy' && (
          <>
            <CopyBlock text={step.text} color={color} />
            {step.desc && <div style={s.stepDesc}>{step.desc}</div>}
          </>
        )}
        {step.type === 'info' && (
          <>
            <div style={s.infoBox(color)}>{step.text}</div>
            <div style={s.stepDesc}>Приклад відповіді Claude після `/resume`</div>
          </>
        )}
        {step.type === 'command_picker' && <CommandPicker color={color} />}
        {step.type === 'manual_picker' && <ManualPicker color={color} />}
      </div>
    </div>
  );
}

function ScenarioDetails({ scenario }) {
  const { color, icon, title, steps } = scenario;
  return (
    <div style={s.details(color)}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
        <span style={{ fontSize: 22 }}>{icon}</span>
        <span style={{ fontSize: 16, fontWeight: 700, color }}>{title}</span>
        <span style={{ fontSize: 12, color: '#64748b' }}>— інструкція нижче</span>
      </div>
      {steps.map((step, i) => (
        <StepBlock key={i} step={step} idx={i} color={color} />
      ))}
    </div>
  );
}

// ─── Головна сторінка ───────────────────────────────────────────────────────

export default function SeamlessSessionPage() {
  const [selected, setSelected] = useState('same_pc');
  const scenario = SCENARIOS.find(s => s.id === selected);

  return (
    <div style={s.page}>
      <div style={s.h1}>🔑 Безшовна сесія</div>
      <div style={s.sub}>Інструкція старту нової сесії Claude Code — вибери свій варіант</div>

      {/* ── Вибір сценарію ── */}
      <div style={s.sectionTitle}>Оберіть ситуацію</div>
      <div style={s.grid4}>
        {SCENARIOS.map(sc => (
          <div
            key={sc.id}
            style={s.scenarioCard(selected === sc.id, sc.color)}
            onClick={() => setSelected(sc.id)}
          >
            <div style={s.badge(sc.color)}>{sc.badge}</div>
            <div style={s.scenarioIcon}>{sc.icon}</div>
            <div style={s.scenarioTitle(selected === sc.id, sc.color)}>{sc.title}</div>
            <div style={s.scenarioSub}>{sc.subtitle}</div>
          </div>
        ))}
      </div>

      {/* ── Деталі вибраного сценарію ── */}
      {scenario && <ScenarioDetails scenario={scenario} />}

      {/* ── Ритуал після успіху ── */}
      <div style={s.sectionTitle}>Після кожного успіху — обов'язково</div>
      <div style={{ ...s.ritualCard, marginBottom: 32 }}>
        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>
          Виконай ці 3 кроки після кожного D-номера, щоб наступна сесія бачила актуальний стан:
        </div>
        <div style={s.ritualGrid}>
          {RITUAL.map((r, i) => (
            <div key={i} style={s.ritualItem(i)}>
              <div style={s.ritualNum(i)}>{r.num}</div>
              <div>
                <div style={{ fontSize: 13, color: '#cbd5e1' }}>
                  {r.text} <span style={s.inlineCode}>{r.code}</span>
                </div>
                <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>{r.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Ключові файли ── */}
      <div style={s.sectionTitle}>Ключові файли системи</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 8 }}>
        {[
          { path: 'videobot-docs/_SESSIONS/ANCHOR.md',     desc: 'Якір — тексти для вставки у нову сесію' },
          { path: 'videobot-docs/_SESSIONS/ONBOARDING.md', desc: 'Повний онбординг нової машини' },
          { path: 'videobot-docs/_SESSIONS/SECURITY.md',   desc: 'Security чеклісти' },
          { path: 'videobot-docs/COORDINATION.md',          desc: 'Traffic light між Media і PL' },
          { path: 'videobot-docs/WORKING_RULES.md',         desc: '5 Заповідей + усі правила' },
          { path: '/home/cc_media/.claude/commands/',        desc: 'Skills: resume.md + onboard.md' },
        ].map((f, i) => (
          <div key={i} style={{ display: 'flex', gap: 10, background: 'rgba(0,0,0,.2)', borderRadius: 8, padding: '10px 14px', alignItems: 'flex-start' }}>
            <span style={{ color: '#64748b', fontSize: 13, marginTop: 1 }}>📄</span>
            <div>
              <div style={{ fontFamily: 'monospace', fontSize: 11, color: '#86efac' }}>{f.path}</div>
              <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>{f.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
